var $ = jQuery.noConflict();
// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});
})();

document.addEventListener("DOMContentLoaded", function () {

	// Revenue per country: dynamic svg chart
	const selects = document.querySelectorAll('.revenue__country');

    selects.forEach(select => {
        const wrapper = select.closest('.revenue');
        const progressCircle = wrapper.querySelector('.progress-circle');
        const result = wrapper.querySelector('.revenue__number'); // On met à jour directement ce texte

        // Circle perimeter
        const circumference = 2 * Math.PI * 25; // 2πr (r = 25, car le rayon du cercle est 25)

		progressCircle.style.strokeDasharray = `${circumference}`;
        progressCircle.style.strokeDashoffset =`${circumference}`;

		const defaultCountry = select.getAttribute('data-defaultcountry');

		let defaultPercentage = 0;
        for (let option of select.options) {
            if (option.textContent.trim() === defaultCountry) {
                option.selected = true;
                defaultPercentage = parseFloat(option.value.replace(",", "."));
                break;
            }
        }

        // Updating text & vectors
        function updateProgress(percentage) {
            if (typeof percentage !== "string") return;
            percentage = percentage.replace(",", ".");
            percentage = parseFloat(percentage);

            if (isNaN(percentage)) return;
            const offset = circumference * (1 - (percentage / 100));

            progressCircle.style.strokeDashoffset = offset;
            result.innerText = percentage + "%";
        }

        // Select the first element by default
        updateProgress(select.value);

        // Updating on change event
        select.addEventListener("change", function() {
            updateProgress(this.value);
        });
    });

	// Sélection des éléments
	const cards = document.querySelectorAll(".card-user"); // Toutes les cartes
	const loginCard = document.querySelector(".card.login");
	const resetCard = document.querySelector(".card.password-reset");
	const requestCard = document.querySelector(".card.account-request");

	const setPasswordButton = document.querySelector(".set-password-link");
	const forgotPasswordButton = document.querySelector(".forgot-password-link");
	const requestAccountButton = document.querySelector(".account-request-link");
	const backToLoginButtons = document.querySelectorAll(".back-to-login-link");

	// Fonction pour afficher une card et masquer les autres
	function showCard(targetCard) {
		cards.forEach(card => {
			if (!card.classList.contains("d-none")) {
				card.classList.add("fade-out");
				setTimeout(() => {
					card.classList.add("d-none");
					card.classList.remove("fade-out");
				}, 300);
			}
		});

		setTimeout(() => {
			targetCard.classList.remove("d-none");
			targetCard.classList.add("fade-in");
		}, 300);
	}

	// Gestion des événements
	if (setPasswordButton) {
		setPasswordButton.addEventListener("click", () => showCard(resetCard));
	}

	if (forgotPasswordButton) {
		forgotPasswordButton.addEventListener("click", () => showCard(resetCard));
	}
	
	if (requestAccountButton) {
		requestAccountButton.addEventListener("click", () => showCard(requestCard));
	}
	
	backToLoginButtons.forEach(button => {
		button.addEventListener("click", () => showCard(loginCard));
	});
	
	// View more button on press releases listing
	if (document.body.classList.contains('page-template-press')){
		const pressItems = document.querySelectorAll(".press-item");
		const viewmoreBtn = document.querySelector(".view-more");

		let visibleCount = 3; // initial number of visible posts
		const increment = 6; // posts to display on button click
		let expanded = false;

		viewmoreBtn.addEventListener("click", function () {
			if(!expanded) {
				let hiddenItems = Array.from(pressItems).filter(item => item.style.display === "none");

				hiddenItems.slice(0, increment).forEach((item, index) => {
					setTimeout(() => {
						item.style.display = "list-item";
						item.style.opacity = 0;
						item.style.transition = "opacity 0.5s ease-in-out";
						requestAnimationFrame(() => {
							item.style.opacity = 1;
						});
					}, index * 100); // progressive effect
				});
	
				visibleCount += increment;
	
				if (visibleCount >= pressItems.length) {
					viewmoreBtn.textContent = "View less"; // Change le texte du bouton
					expanded = true;
				}
			} else {
				// View less items button : back to initial display
				pressItems.forEach((item, index) => {
					if (index >= 3) {
						item.style.opacity = 0;
						setTimeout(() => {
							item.style.display = "none";
						}, 300);
					}
				});

				visibleCount = 3;
				viewmoreLabel.textContent = "See more press releases";
				expanded = false;
			}
		});
	}

	// Switch from inline to 3 cards/columns on Press room page
	if (document.body.classList.contains('page-template-press')){
		let toggleSwitch = document.getElementById("gridSwitch");
		let switchText = document.getElementById("gridSwitchText");
		const archivePress = document.querySelector(".archive__press");

		// Initial mode
		archivePress.classList.add("list-view");

		toggleSwitch.addEventListener("change", function () {
			if (toggleSwitch.checked) {
				archivePress.classList.remove("grid-view");
				archivePress.classList.add("list-view");
				switchText.textContent = "List";
			} else {
				archivePress.classList.remove("list-view");
				archivePress.classList.add("grid-view");
	
				// Temporary class for animation
				setTimeout(() => {
					archivePress.classList.add("animating");
				}, 50);
	
				switchText.textContent = "Grid";
			}
		});
	}

	// Media filters
	if (document.body.classList.contains('page-template-media-library')){
		const buttons = document.querySelectorAll('.filter');
		const items = document.querySelectorAll('.media-library-item');

		buttons.forEach(button => {		
			button.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				if (this.classList.contains('on')) return;

				// Delete active class on all button
				buttons.forEach(btn => {
					if (btn !== this) {
						btn.classList.remove('active');
					}
				});
				this.classList.add('active');

				// Filter with fade effect
				const filter = this.getAttribute('data-filter');
				items.forEach(item => {
					if (filter === 'all' || item.getAttribute('data-category') === filter) {
						item.classList.remove('hidden');
						setTimeout(() => {
							item.style.display = 'block';
						}, 300); // Transition delay
					} else {
						item.classList.add('hidden');
						setTimeout(() => {
							item.style.display = 'none';
						}, 300);
					}
				});
			});
		});
	}

	// Audio player
	if (document.body.classList.contains('page-template-dashboard-logged-in')){
		const players = Array.from(document.querySelectorAll('.emeria-player'));
		players.forEach(player => new Plyr(player, {
			controls: ['play', 'progress', 'current-time', 'duration']
		}));
	}

	// Brand Store Gallery
	if (document.body.classList.contains('page-template-brandstore')){
		const lightbox = GLightbox({
			selector: '.glightbox-gallery',
			loop: true,
			touchNavigation: true
		});
	}
});

// Placeholders on Login form
$(document).ready(function() {
	$('#user_login').attr( 'placeholder', 'Login*' );
	$('#user_pass').attr( 'placeholder', 'Password*' );
	$('#user_email').attr( 'placeholder', 'Email*' );
});